import { Injectable } from '@angular/core';
import {GamePromoModel} from "../models/landing.model";
import {ConfigService} from "./config.service";


@Injectable({
  providedIn: 'root'
})
export class LandingService {

  allFooterLogos = [
    // {name: 'eighteenplus', filename: '18+.svg'},
    // {name: 'android', filename: 'android.svg'},
    // {name: 'iPhone', filename: 'iPhone.svg'},
    // {name: 'microsoft', filename: 'microsoft.svg'},
    // {name: 'cashlib', filename: 'cashlib.png'},
    // {name: 'giropay', filename: 'giropay.png'},
    // {name: 'mastercard', filename: 'mastercard.png'},
    // {name: 'neteller', filename: 'neteller.png'},
    // {name: 'paysafe', filename: 'paysafe.png'},
    // {name: 'postpay', filename: 'postpay.png'},
    // {name: 'skrill', filename: 'skrill.png'},
    // {name: 'ukash', filename: 'ukash.png'},
    // {name: 'upay', filename: 'upay.png'},
    // {name: 'visa', filename: 'visa.png'},
    // {name: 'rival', filename: 'rival.svg'},
    // {name: 'betsoft', filename: 'betsoft.svg'},
    // {name: 'saucify', filename: 'saucify.svg'},
    // {name: 'vivogaming', filename: 'vivogaming.svg'},
    // {name: 'dragongaming', filename: 'dragongaming.svg'}

    {name: 'eighteenplus', filename: '18+.svg'},
    {name: 'iPhone', filename: 'iPhone.svg'},
    {name: 'android', filename: 'android.svg'},
    {name: 'microsoft', filename: 'microsoft.svg'},
    {name: 'betsoft', filename: 'betsoft.svg'},
    {name: 'dragongaming', filename: 'dragongaming.svg'},
    {name: 'saucify', filename: 'saucify.svg'},
    {name: 'vivogaming', filename: 'vivogaming.svg'},
    {name: 'rival', filename: 'rival.svg'},
    {name: 'visa', filename: 'visa.png'},
    {name: 'mastercard', filename: 'mastercard.png'},
    {name: 'neteller', filename: 'neteller.png'},
    {name: 'paysafe', filename: 'paysafe.png'},
    {name: 'ukash', filename: 'ukash.png'}
  ]

  private gamePromoPaths: GamePromoModel[] = [
    { game_name: "mandarin-tiger",
      game_logo: "logo.png",
      promo_img: ["promo_image.png",  "promo_flares.png"],
      background_image: "background.png",
      flares: ["side_flares.png", "treasurebox_flares.png"]
    },
    { game_name: "midnight-mustang",
      game_logo: "MidnightMustang_Logo.png",
      promo_img: ["MidnightMustang_promo.png", "MidnightMustang_Flares_1.png", "MidnightMustang_Flares_2.png"],
      background_image: "background.png",
      flares: ["side_flares.png"]
    },
    { game_name: "777ndb",
      game_logo: "777NDB_logo.png",
      promo_img: ["777NDB_promo.png", "777NDB_flares_1.png", "777NDB_flares_2.png"],
      background_image: "777NDB_background.png",
      flares: ["777NDB_bg_flares_1.png", "777NDB_bg_flares_2.png"]
    },
    { game_name: "chipy",
      game_logo: "chipy_logo.png",
      promo_img: ["chipy_promo_image.png", "chipy_promo_flares_1.png", "chipy_promo_flares_2.png"],
      background_image: "chipy_background.png",
      flares: ["chipy_background_flares_1.png", "chipy_background_flares_2.png"]
    },
    { game_name: "no-deposit-kings",
      game_logo: "NoDepositKings_logo.png",
      promo_img: ["NoDepositKings_promo.png", "NDK_promo_flares_1.png", "NDK_promo_flares_2.png"],
      background_image: "NDK_Background.png",
      flares: ["NDK_background_flares_1.png", "NDK_background_flares_2.png"]
    },
    { game_name: "zeus-thunder-fortunes",
      game_logo: "ZeusThunderFortune_game_logo.png",
      promo_img: ["ZeusThunderFortune_game_promo.png", "ZeusThunderFortune_game_promo_flares_1.png", "ZeusThunderFortune_game_promo_flares_2.png"],
      background_image: "ZeusThunderFortune_Background.png",
      flares: ["ZeusThunderFortune_Background_flares_1.png", "ZeusThunderFortune_Background_flares_2.png"]
    },
    { game_name: "metal-detector-mayan-magic",
      game_logo: "MetalDetector_MayanMagic_logo.png",
      promo_img: ["MetalDetector_MayanMagic_game_promo.png", "MetalDetector_MayanMagic_promo_FLARES_1.png", "MetalDetector_MayanMagic_promo_FLARES_2.png"],
      background_image: "MetalDetector_MayanMagic_Background.png",
      flares: ["MetalDetector_MayanMagic_flares_1.png", "MetalDetector_MayanMagic_flares_2.png"]
    },
    { game_name: "shell-shock",
      game_logo: "ShellShock_logo.png",
      promo_img: ["ShellShock_promo.png", "ShellShock_promo_flares_1.png", "ShellShock_promo_flares_2.png"],
      background_image: "ShellShock_Background.png",
      flares: ["ShellShock_Background_flares_1.png", "ShellShock_Background_flares_2.png"]
    },
    { game_name: "bigger-cash-win",
      game_logo: "BiggerCashWin_logo.png",
      promo_img: ["BiggerCashWin_promo.png", "BiggerCashWin_promo_flares_1.png", "BiggerCashWin_promo_flares_2.png"],
      background_image: "BiggerCashWin_background.png",
      flares: ["BiggerCashWin_background_flares_1.png", "BiggerCashWin_background_flares_2.png"]
    },
    { game_name: "sugar-high",
      game_logo: "sugar_high_offer_logo.png",
      promo_img: ["Sugar_High_Promo_image.png", "Sugar_High_Promo_image_flares_1.png", "Sugar_High_Promo_image_flares_2.png"],
      background_image: "Sugar_High_background.png",
      flares: ["Sugar_High_Background_flares_1.png", "Sugar_High_Background_flares_2.png", "Sugar_High_Background_flares_3.png"]
    },
    { game_name: "hot-offer",
      game_logo: "", //no game included
      promo_img: [],
      background_image: "general_b.png",
      flares: ["general_flare1.png", "general_flare2.png", "general_flare3.png"]
    },
    { game_name: "special-offer",
      game_logo: "", //no game included
      promo_img: [],
      background_image: "background.png",
      flares: ["animated_flare_1.png", "animated_flare_2.png", "animated_flare_3.png"]
    },
    { game_name: "exclusive-offer",
      game_logo: "", //no game included
      promo_img: [],
      background_image: "background.png",
      flares: ["animated_flare_1.png", "animated_flare_2.png", "animated_flare_3.png"]
    },
    { game_name: "888-dream-dragon",
      game_logo: "888_Dream_Dragon_logo.png",
      promo_img: ["promo_image.png", "promo_image_flares_1.png", "promo_image_flares_2.png"],
      background_image: "background.png",
      flares: ["background_flares_1.png", "background_flares_2.png"]
    },
    { game_name: "crazy-clover-cash",
      game_logo: "game_logo.png",
      promo_img: ["promo_image.png", "promo_image_flares_1.png", "promo_image_flares_2.png"],
      background_image: "background.png",
      flares: ["background_flares_1.png", "background_flares_2.png"]
    },
    { game_name: "jenny-nevada",
      game_logo: "game_logo.png",
      promo_img: ["promo_image.png", "promo_image_flares_1.png", "promo_image_flares_2.png", "promo_image_flares_3.png"],
      background_image: "background.png",
      flares: ["background_flares_1.png", "background_flares_2.png", "background_flares_3.png"]
    },
    { game_name: "lcb",
      game_logo: "lcb_logo.png",
      promo_img: ["lcb_promo_image.png", "lcb_promo_flares_1.png", "lcb_promo_flares_2.png"],
      background_image: "lcb_background.png",
      flares: ["lcb_background_flares_1.png", "lcb_background_flares_2.png"]
    },
    { game_name: "super-hoopers",
      game_logo: "game_logo.png",
      promo_img: ["promo_image.png", "promo_image_flares_1.png", "promo_image_flares_2.png"],
      background_image: "background.png",
      flares: ["background_flares_1.png", "background_flares_2.png", "background_flares_3.png"]
    }


  ];


  constructor(
    private configs: ConfigService
  ) {
    if (this.configs.name === 'slotvibe'){
      this.gamePromoPaths = [
        { game_name: "slotvibe",
          game_logo: "",
          promo_img: ["spin_wheel.png", "spin_wheel_bubbles.png", "spin_wheel_glow.png" ],
          background_image: "bg.png",
          flares: ["bg_glow.png"]
        },
        { game_name: "crypto",
          game_logo: "",
          promo_img: ["right_logo.png", "right_stars.png", "right_outline_glow.png" ],
          background_image: "bg.png",
          flares: ["bg_glow.png"]
        },
        { game_name: "exclusive-promo",
          game_logo: "",
          promo_img: ["promo_image.png", "promo_image_flare.png"],
          background_image: "bg_layer1.png",
          flares: ["bg_flare1.png"]
        },
        { game_name: "special-promo",
          game_logo: "",
          promo_img: ["promo.png", "promo_flares.png"],
          background_image: "bg.png",
          flares: ["bg_flare.png"]
        },
        { game_name: "premium-promo",
          game_logo: "",
          promo_img: ["promo_image.png", "promo_image_flare.png"], //logo build in promo image
          background_image: "bg_layer.png",
          flares: ["bg_flare.png"]
        },
        { game_name: "mega-promo",
          game_logo: "",
          promo_img: ["promo_image.png", "promo_flare.png"], //figure in BG (promo img not shown from template)
          background_image: "bg_with_figure.png",
          flares: ["bg_flare.png"]
        },
        { game_name: "hot-promo",
          game_logo: "",
          promo_img: ["Promo_Image.png", "Promo_Image_Layer2.png"],
          background_image: "BG.png", //logo build in bg
          flares: ["BG_Flare.png"]
        },
      ]
    }

    if (this.configs.name === '24slots' || this.configs.name === 'betrophy'){
      this.gamePromoPaths.push(
        { game_name: "xmas",
          game_logo: "", //no game included
          promo_img: [],
          background_image: "xmas_LP_background_page_1.png",
          flares: ["xmas_LP_animated_flares_1_page_1.png", "xmas_LP_animated_flares_2_page_1.png"]
        },
        { game_name: "sports",
          game_logo: "", //no game included
          promo_img: ["promo.png", "promo_flares.png"],
          background_image: "bg.png",
          flares: ["flares.png"]
        },
      )
    }

    if (this.configs.name === 'betrophy'){
      this.gamePromoPaths.push(
        { game_name: "welcome-offer",
          game_logo: "", //no game included
          promo_img: [],
          background_image: "background.png",
          flares: ["animated_flares_1.png", "animated_flares_2.png", "animated_flares_3.png"]
        },
        { game_name: "welcome-reward",
          game_logo: "", //no game included
          promo_img: [],
          background_image: "background.png",
          flares: ["animated_flares_1.png", "animated_flares_2.png", "animated_flares_3.png"]
        },
        { game_name: "welcome-package",
          game_logo: "", //no game included
          promo_img: [],
          background_image: "background.png",
          flares: ["animated_flares_1.png", "animated_flares_2.png", "animated_flares_3.png"]
        },
        { game_name: "welcome-package",
          game_logo: "", //no game included
          promo_img: [],
          background_image: "background.png",
          flares: ["animated_flares_1.png", "animated_flares_2.png", "animated_flares_3.png"]
        },
        { game_name: "welcome-easter-treat",
          game_logo: "", //no game included
          promo_img: [],
          background_image: "background.png",
          flares: ["animated_flares_1.png", "animated_flares_2.png", "animated_flares_3.png"]
        },
      )
    }

    if (this.configs.name === '24slots'){
      this.gamePromoPaths.push(
        { game_name: "easter-pack",
          game_logo: "", //no game included
          promo_img: [],
          background_image: "background.png",
          flares: ["animated_flares_1.png", "animated_flares_2.png", "animated_flares_3.png"]
        },
        { game_name: "cowboy",
          game_logo: "",
          promo_img: ["cowboy_promo.png"],
          background_image: "cowboy_bg.jpg",
          flares: []
        }
        )
    }

    if (this.configs.name === 'wikiluck'){
      this.gamePromoPaths = [
        { game_name: "new-deal",
          game_logo: "", //no game included
          promo_img: [],
          background_image: "background_1.png",
          flares: ["bg_animated_flares_1.png", "bg_animated_flares_2.png", "bg_animated_flares_3.png"]
        },
        { game_name: "big-deal",
          game_logo: "", //no game included
          promo_img: [],
          background_image: "background_1.png",
          flares: ["bg_animated_flares_1.png", "bg_animated_flares_2.png", "bg_animated_flares_3.png"]
        },
        { game_name: "easter-deal",
          game_logo: "", //no game included
          promo_img: [],
          background_image: "background.png",
          flares: ["animated_flares_1.png", "animated_flares_2.png", "animated_flares_3.png"]
        },
        { game_name: "cowboy",
          game_logo: "",
          promo_img: ["cowboy_promo.png"],
          background_image: "cowboy_bg.jpg",
          flares: []
        }
      ]
    }
  }

  public getGamePromoPaths(): GamePromoModel[] {
    return this.gamePromoPaths;
  }

}
